<template>
  <div>
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <SuccessModal ref="SuccessModal"></SuccessModal>
    <YesNoModal ref="YesNoModal"></YesNoModal>
    <v-layout fill-height row mr-1 ml-1 mt-2>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Customer Modify</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step step="1" @click="e1 = 1">Customer Details</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" @click="e1 = 2">Venue Details</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" @click="e1 = 3">Customer-Users</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" @click="e1 = 4">Inspection & Task Details</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" @click="e1 = 5">Ops-Manager Assessment Inspections</v-stepper-step>
            </v-stepper-header>
            <!-- CUSTOMER -->
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-5" color="grey lighten-5" elevation="4">
                  <v-layout row wrap ma-4>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <v-form @submit.prevent="SubmitCustomerForm" ref="CustomerForm" v-model="valid">
                        <v-card-text xs12 mt-3>
                          <v-flex xs6>
                            <v-switch label="InActive" v-model="customerForm.InActive"></v-switch>
                          </v-flex>
                          <v-layout>
                            <v-flex xs6>
                              <v-combobox v-model="selectedSystemUsers" multiple :items="systemUserList"
                                item-text="SystemUserFullName" item-value="SystemUserID" label="Assign system users" chips
                                @change="checkSelectedSystemUsers()" :search-input.sync="search"></v-combobox>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6>
                              <v-select v-model="customerForm.RegionID" label="Region" :rules="fieldRules"
                                :items="regionItems" item-text="Name" item-value="ID"></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs12>
                              <v-text-field autocomplete="off" aria-autocomplete="none" label="Company Name" v-model="customerForm.Name" :rules="fieldRules">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" label="First Name (contact person)" v-model="customerForm.FirstName">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field autocomplete="off" aria-autocomplete="none" label="Last Name (contact person)" v-model="customerForm.LastName">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-start row>
                            <v-flex mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" label="Contact Telephone Number" v-model="customerForm.ContactTel"
                                mask="phone"></v-text-field>
                            </v-flex>
                            <v-flex>
                              <v-text-field autocomplete="off" aria-autocomplete="none" label="Contact Email Address" v-model="customerForm.EmailAddress">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-start row>
                            <v-flex mr-2 md6>
                              <input  ref="autocompleteCustomer" placeholder="Street Address" class="search-location"
                                onfocus="value = ''" type="text">
                            </v-flex>
                          </v-layout>
                          <v-layout justify-start row>
                            <v-flex mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Address Line 1" v-model="customerForm.AddressLine1"
                                :rules="fieldRules"></v-text-field>
                            </v-flex>
                            <v-flex>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Address Line 2" v-model="customerForm.AddressLine2">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-start row>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Suburb" v-model="customerForm.Suburb" :rules="fieldRules">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Province" v-model="customerForm.Province"
                                :rules="fieldRules"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-start row>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Latitude" v-model="customerForm.Lattitude"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field autocomplete="off" aria-autocomplete="none" disabled label="Longitude" v-model="customerForm.Longitude"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <h3 class="mt-3 mb-2">Login credentials</h3>
                          <v-layout justify-start row>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field  label="Username" v-model="customerForm.Username" :rules="fieldRules"
                                autocomplete="new-password">
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                              <v-text-field label="Password"
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'"
                                v-model="customerForm.Password" :rules="fieldRules" autocomplete="new-password">
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-end>
                            <v-btn color="primary" @click="SubmitCustomerForm()"
                              v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE')" :disabled="!valid">Save</v-btn>
                            <v-btn @click="e1 = 2" outline color="secondary">next</v-btn>
                            <v-btn flat @click="$router.push('/customers/dashboard')">Cancel</v-btn>
                          </v-layout>
                        </v-card-text>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <!-- VENUE -->
              <v-stepper-content step="2">
                <CustomerVenueModifyWizard :prop_RegionID="customerForm.RegionID" :prop_VenueList="VenueList" />
                <v-layout justify-end>
                  <v-btn flat @click="e1 = 1" outline color="secondary">Previous</v-btn>
                  <v-btn color="primary" @click="e1 = 3">Next</v-btn>
                </v-layout>
              </v-stepper-content>

              <!-- CUSTOMER-USER -->
              <v-stepper-content step="3">
                <CustomerUserModifyWizard />
                <v-layout justify-end>
                  <v-btn flat @click="e1 = 2" outline color="secondary">Previous</v-btn>
                  <v-btn color="primary" @click="e1 = 4">Next</v-btn>
                </v-layout>
              </v-stepper-content>

              <!-- INSPECTION TEMPLATE -->
              <v-stepper-content step="4" v-if="e1 == 4">
                <CustomerInspectionModifyWizard />
                <v-layout justify-end>
                  <v-btn flat @click="e1 = 3" outline color="secondary">Previous</v-btn>
                  <v-btn color="primary" @click="e1 = 5">Next</v-btn>
                </v-layout>
              </v-stepper-content>

              <!-- OPS MANAGER ASSESSMENT INSPECTIONS -->
              <v-stepper-content step="5" v-if="e1 == 5">
                <CustomerAssessmentModifyWizard />
                <v-layout justify-end>
                  <v-btn flat @click="e1 = 4" outline color="secondary">Previous</v-btn>
                  <v-btn color="primary" @click="$router.push('/customers/dashboard')">Done</v-btn>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import JWT from "jsonwebtoken";
  import CustomerVenueModifyWizard from "@/components/common/customers/modify-wizard/customer-venue-modify.vue";
  import CustomerUserModifyWizard from "@/components/common/customers/modify-wizard/customer-user-modify.vue";
  import CustomerInspectionModifyWizard from "@/components/common/customers/modify-wizard/customer-inspection-modify-wizard.vue";
  import CustomerAssessmentModifyWizard from "@/components/common/customers/modify-wizard/customer-opsmanager-assessment-modify.vue";

  export default {
    data() {
      let self = this;
      return {
        search: null,
        CustomerID: 0,
        e1: 0,
        VenueList: [],
        // CUSTOMER
        selectedSystemUsers: [],
        systemUserList: [],
        place: "",
        places: [],
        showPassword: false,
        regionItems: [],
        customerForm: {
          ID: 0,
          RegionID: 0,
          Name: null,
          FirstName: null,
          LastName: null,
          ContactTel: null,
          EmailAddress: null,
          AddressLine1: null,
          AddressLine2: null,
          Lattitude: null,
          Longitude: null,
          Suburb: null,
          Province: null,
          Username: null,
          Password: null,
          InActive: false
        },
        valid: false,
        place: null,
        fieldRules: [v => !!v || "Field is required"],
        emailRules: [
          v => !!v || "E-mail is required",
          v => /.+@.+/.test(v) || "E-mail must be valid"
        ],
        checkUsername: null
      };
    },
    components: {
      CustomerVenueModifyWizard,
      CustomerUserModifyWizard,
      CustomerInspectionModifyWizard,
      CustomerAssessmentModifyWizard
    },
    watch: {
      selectedSystemUsers() {
        this.search = ''
      }
    },
    mounted() {
      let self = this;
      self.CustomerID = self.$route.params.id;
      self.fetchCustomerInfo();
      self.fetchRegions();
      self.fetchSystemUsers();

      // MAPS
      this.autocomplete = new google.maps.places.Autocomplete(
        self.$refs.autocompleteCustomer, {
          types: ["address"]
        }
      );
      this.autocomplete.addListener("place_changed", () => {
        self.place = this.autocomplete.getPlace();
        self.customerForm.AddressLine1 =
          self.place.address_components[0].short_name +
          " " +
          self.place.address_components[1].long_name;
        self.customerForm.AddressLine2 =
          self.place.address_components[2].short_name;
        self.customerForm.Suburb = self.place.address_components[3].short_name;
        self.customerForm.Province = self.place.address_components[5].long_name;
        self.customerForm.Lattitude = self.place.geometry.location.lat();
        self.customerForm.Longitude = self.place.geometry.location.lng();
      });
    },
    methods: {
      // setting text of system user
      text: item => item.Title + " " + item.FirstName + " " + item.LastName,
      fetchCustomerInfo() {
        let self = this;

        self
          .get(`Customer/GetCustWithLinkedUsers?customerID=${self.CustomerID}`)
          .then(r => {
            console.log("CUSTOMER INFO", r.data);
            self.customerForm = r.data.Customer;
            // self.customerForm = r.data;
            self.checkUsername = r.data.Customer.Username;
            self.selectedSystemUsers = r.data.SystemUsers;
          })
          .catch(e => {
            console.log(e);
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText("Failed to fetch customer info");
          });
      },
      fetchSystemUsers() {
        let self = this;

        self
          .get("SystemUser/getAll")
          .then(r => {
            self.systemUserList = r.data;
            //self.fetchSystemUserLink();
          })
          .catch(error => {
            console.log(err);
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText("Failed to fetch system users");
          });
      },
      fetchSystemUserLink() {
        let self = this;
        self.selectedSystemUsers = [];

        self.get(`CustomerUserLink/GetIntData?customerID=${self.CustomerID}`)
          .then(r => {
            console.log("CUST-USER-LINK", r.data);
            //self.selectedSystemUsers = r.data;

            console.log("user link after fetching", self.selectedSystemUsers)

            r.data.forEach(link => {
              var retVal = self.systemUserList.filter(systemUser => {
                return link.SystemUserID == systemUser.ID;
              });
              console.log("[LINKED SYSTEM USERS]", retVal);
              self.selectedSystemUsers.push(retVal[0]);
            });
            console.log("[LINK?]", self.selectedSystemUsers)
          });
      },
      fetchRegions() {
        let self = this;

        self.get("Region").then(r => {
          self.regionItems = r.data;
        });
      },
      checkSelectedSystemUsers() {
        let self = this;

        let selectedSystemUsersID = [];
        self.$nextTick(() => {
          self.selectedSystemUsers.forEach(el => {
            selectedSystemUsersID.push(el.ID);
          });
          console.log(selectedSystemUsersID);
        });
      },
      SubmitCustomerForm() {
        var self = this;
        let Request = self.customerForm;

        console.log("CUSTOMER REQUEST TO UPDATE", Request);
        if (self.checkUsername == self.customerForm.Username) {
          // checks if username has been touched; if its the same, then just post - else check
          self
            .put(`Customer?id=${self.CustomerID}`, Request)
            .then(res => {
              self.checkUsername = res.data.Username;
              let selectedSystemUsersID = [];
              self.$nextTick(() => {
                self.selectedSystemUsers.forEach(el => {
                  selectedSystemUsersID.push(el.ID);
                });

                // post system user allocation
                console.log("SELECTED SYSTEM USERS", selectedSystemUsersID);
                let allocationRequest = {
                  SystemUserIdList: selectedSystemUsersID,
                  CustomerID: self.CustomerID,
                  CanNotify: false
                };
                console.log("ALLOCATION REQUEST", allocationRequest);
                self
                  .delete(`CustomerUserLink?customerID=${self.CustomerID}`)
                  .then(() => {
                    self
                      .post("CustomerUserLink", allocationRequest)
                      .then(r => {
                        // GO TO CUSTOMER VENUE COMPONENT
                        self.e1 = 2;
                      })
                      .catch(e => {
                        console.log(e);
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(
                          "Failed to update customeruser allocation"
                        );
                      });
                  });
              });
            })
            .catch(err => {
              console.log(err);
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText("Failed to update customer");
            });
        } else {
          self.TestUsernameExists().then(result => {
            if (result == true) {
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText("Username is taken");
            } else {
              self.put(`Customer?id=${self.CustomerID}`, Request)
                .then(res => {
                  self.CustomerID = res.data.ID;
                  self.checkUsername = res.data.Username;
                  let selectedSystemUsersID = [];
                  self.$nextTick(() => {
                    self.selectedSystemUsers.forEach(el => {
                      selectedSystemUsersID.push(el.ID);
                    });

                    // post system user allocation
                    let allocationRequest = {
                      SystemUserIdList: selectedSystemUsersID,
                      CustomerID: self.CustomerID,
                      CanNotify: false
                    };
                    console.log("ALLOCATION REQUEST", allocationRequest);
                    self.post("CustomerUserLink", allocationRequest).then(r => {
                      console.log("ALLOCATION RESPONSE", r.data)
                      // GO TO CUSTOMER VENUE COMPONENT
                      self.e1 = 2;
                    });
                  });
                })
                .catch(err => {
                  console.log(err);
                  self.$refs.ErrorModal.show();
                  self.$refs.ErrorModal.setText("Failed to create customer");
                });
            }
          });
        }
      },
      TestUsernameExists() {
        let self = this;
        return new Promise(resolve => {
          self
            .get(`Customer/Exists?username=${self.customerForm.Username}`)
            .then(result => {
              resolve(result.data);
            })
            .catch(error => {
              resolve(false);
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText("Failed to check username");
            });
        });
      }
    }
  };
</script>

<style scoped>
  .Types {
    min-height: 200px;
    min-width: 200px;
    margin: 10px;
  }

  .active {
    border-style: solid;
    /* border-color: #0a417c !important; */
  }

  .item {
    transition: 0.3s ease;
    cursor: pointer;
    min-height: 200px;
    min-width: 200px;
    margin: 10px;
  }
</style>